/* eslint-disable react/no-danger */
import React from 'react';
import styled from 'styled-components';
import { Check } from '../../../../icons';
import { CARRIER } from '../../../constants';
import { SectionItem } from '../StyledDropdownComponents';

export function renderRow(rowItem, selectedItem, clickHandler, focusState, list) {
    const { id, tag: Tag = 'li' } = rowItem;
    let { name } = rowItem;
    const key = list ?
        `${id}-${name.substring(0, 5)}-${list}` :
        `${id}-${name.substring(0, 5)}`;

    if (id === CARRIER.BLUE_CROSS_BLUE_SHIELD) {
        name += ' (BCBS)';
    }

    const selected = isSelected(rowItem, selectedItem);

    return (
        <Tag
            key={key}
            data-prod-guids={`${key}:[d1d2f34b]`}
            data-row-key={key}
            data-test="insurance-picker-row"
            onClick={() => clickHandler(rowItem)}
        >
            <SectionItem
                innerRef={focusState && focusState.addItem(selected)}
                selected={selected}
            >
                <span dangerouslySetInnerHTML={{ __html: name }}></span>
                {renderSelected(selected)}
            </SectionItem>
        </Tag>
    );
}

function isSelected(rowItem, selectedItem) {
    return selectedItem && selectedItem.id === rowItem.id;
}

function renderSelected(selected) {
    if (!selected) {
        return;
    }

    return (
        <SelectedIcon
            data-test="selected-icon"
            height={10.5882352944}
        />
    );
}

const SelectedIcon = styled(Check)`
    position: absolute;
    right: 28px;
    top: 10px;
`;
